import { Flex, Typography } from 'antd';
import GenerateLoading from 'Components/AICard/GenerateLoading';
import { useEffect } from 'react';
import { AI_CHECKER_GA_EVENT } from 'Containers/Teleconsult/Main/AINotes/constants';

import useCheckHealthSummary from '../../hooks/useCheckHealthSummary';
import Feedback from '../Feedback/Feedback';
import Header from '../Header';
import useAiCheckerLogEvent from '../../hooks/useAiCheckerLogEvent';

import styles from './Content.less';
import EvaluationContent from './EvaluationContent';

const LoadingContent = () => (
  <Flex
    vertical
    gap={0}
    justify="center"
    align="center"
    style={{ maxWidth: 280, margin: '0 auto' }}>
    <GenerateLoading />
    <Typography.Title level={4} style={{ margin: 0 }}>
      Evaluation in progress...
    </Typography.Title>
    <Typography.Text style={{ textAlign: 'center' }}>
      AI Checker is reviewing your note and preparing the evaluation.
    </Typography.Text>
  </Flex>
);

const Content = () => {
  const { data: content, isLoading } = useCheckHealthSummary();

  const { id, userFeedback, score, consultId, status } = content || {};

  const { logAICheckerEvent } = useAiCheckerLogEvent(score);

  useEffect(() => {
    if (status === 'completed') {
      logAICheckerEvent(AI_CHECKER_GA_EVENT.AI_CHECKER_REPORT_VIEW, {
        teleconsult_id: consultId,
      });
    }
  }, [score, logAICheckerEvent, status, consultId]);

  return (
    <Flex className={styles.container} vertical gap={0}>
      <div className={styles.header}>
        <Header title={<Typography.Title level={5}>AI Checker</Typography.Title>} icon={null} />
      </div>
      <Flex className={styles.content} vertical>
        {isLoading ? <LoadingContent /> : <EvaluationContent evaluation={content} />}
        {!isLoading && (
          <Feedback
            id={id}
            consultId={content.consultId}
            score={score}
            userFeedback={userFeedback}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default Content;
